import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";

/**
 * @module ol/AssertionError
 */
import { VERSION } from './util.js';
/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */

var AssertionError =
/*#__PURE__*/
function (_Error) {
  _inherits(AssertionError, _Error);

  /**
   * @param {number} code Error code.
   */
  function AssertionError(code) {
    var _this;

    _classCallCheck(this, AssertionError);

    var path = VERSION === 'latest' ? VERSION : 'v' + VERSION.split('-')[0];
    var message = 'Assertion failed. See https://openlayers.org/en/' + path + '/doc/errors/#' + code + ' for details.';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, message));
    /**
     * Error code. The meaning of the code can be found on
     * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
     * the version found in the OpenLayers script's header comment if a version
     * other than the latest is used).
     * @type {number}
     * @api
     */

    _this.code = code;
    /**
     * @type {string}
     */

    _this.name = 'AssertionError'; // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40

    _this.message = message;
    return _this;
  }

  return AssertionError;
}(_wrapNativeSuper(Error));

export default AssertionError;